import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {

 Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button
} from "@chakra-ui/react";
import {
  Box,
  Flex,
  Img,
  Switch,
  Tooltip
} from "@chakra-ui/react";
// import Select from "react-select";
import {
  TYPES_OF_SEGMENT_METRICS,
  TYPES_OF_SYSTEMATIC_METRICS,
  // TYPES_OF_METRICS,
} from "../../constants/metrics";
import Loader from "../../components/Loader/Loader";
// import RegistrationPopUp from "../RegistrationPopUp";
import IndustryObservations from "../../components/IndustryObservations/IndustryObservations";
import UnlockRegistration from "../../shared/UnlockRegistration/UnlockRegistration";
import bulb_on from "../../assets/images/bulb-on.png";
import cross_icon from "../../assets/images/cross-icon.png";
import AdvisoryNotes from "../../components/AdvisoryNotes/AdvisoryNotes";
// import { useTourContext } from "../../customHooks/useTourContext";
import { useNavigate, useParams } from "react-router-dom";
import downarrowmenu from "../../assets/images/arrow-down.png";
import uparrowmenu from "../../assets/images/arrow-up.png";
import sales from "../../assets/images/sales.png";
import distribution from "../../assets/images/distribution.png";
import hr from "../../assets/images/hr.png";
import production from "../../assets/images/production.png";
import operation from "../../assets/images/operation.png";
import financing from "../../assets/images/financing.png";
import { SegmentTabs } from "../../shared/Sector/SegmentTabs";
import { getSectorWiseById } from "../../actions/sector/sectorActions";
import Sales from "./Chart/Sales";
import Distribution from "./Chart/Distrubution";
import Production from "./Chart/Production";
import Operations from "./Chart/Operations";
import HR from "./Chart/HR";
import Finance from "./Chart/Finance";
import SectorChatbot from "./SectorChatbot";

const sectorWiseMetricKeys = [
  "totalShareholdersEquity",
  "totalDebt",
  "totalSales",
  "totalEbitda",
  "totalTangibleAssets",
  "totalIntangibleAssets",
  "totalFinancialAssets",
  "totalLongTermAssetsUnderDevelopment",
  "totalMaterialsCost",
  "totalInterest",
  "totalEmployeeCost",
  "totalTax",
  "averageInventory",
  "totalWorkingCapital",
  "totalTradeReceivables",
  "totalTradePayables",
];

const segmentMetricKeysMapper = [
  // Sales Metrics
  {
    key: "totalSales",
    label: "Total Sales",
    holder: "Sales",
    sublevel: [
      { skey: "income", slabel: "Income" }
    ],
  },
  {
    key: "totalEbitda",
    label: "Total EBITDA",
    holder: "Sales",
    sublevel: [
      { skey: "financeCosts", slabel: "Finance Costs" },
      { skey: "profitOrLossBeforeEIT", slabel: "Profit Or Loss BeforeEIT" },
      { skey: "depreciationAndAmortisationExpense", slabel: "Depreciation And Amortisation Expense" }
    ],
  },

  // Distribution Metrics
  {
    key: "totalTradeReceivables",
    label: "Total Trade Receivables",
    holder: "Distribution",
    sublevel: [
      { skey: "currTradeReceivables", slabel: "Current Trade Receivables" },
      { skey: "nonCurrTradeReceivables", slabel: "Non-Current Trade Receivables" }
    ],
  },
  {
    key: "averageInventory",
    label: "Average Inventory",
    holder: "Distribution",
    sublevel: [
      { skey: "currentInventory", slabel: "Current Inventory" },
      { skey: "previousInventory", slabel: "Previous Inventory" }
    ],
  },

  // Production Metrics
  {
    key: "totalMaterialsCost",
    label: "Total Materials Cost",
    holder: "Production",
    sublevel: [
      { skey: "changesInStockOfFinishedGoodsWIPAndSIT", slabel: "Changes In Stock Of Finished Goods WIP And SIT" },
      { skey: "costOfMaterialsConsumed", slabel: "Cost Of Materials Consumed" },
      { skey: "purchasesOfStockInTrade", slabel: "Purchases Of Stock InTrade" }
    ],
  },
  {
    key: "totalTradePayables",
    label: "Total Trade Payables",
    holder: "Production",
    sublevel: [
      { skey: "currTradePayable", slabel: "Current Trade Payable" },
      { skey: "nonCurrTradePayable", slabel: "Non-Current Trade Payable" }
    ],
  },

  // Operations Metrics
  {
    key: "totalTangibleAssets",
    label: "Total Tangible Assets",
    holder: "Operations",
    sublevel: [
      { skey: "investmentProperties", slabel: "Investment Properties" },
      { skey: "propertyPlantAndEquipment", slabel: "Property Plant And Equipment" },
      { skey: "rightOfUseAssets", slabel: "Right Of UseAssets" }
    ],
  },
  {
    key: "totalIntangibleAssets",
    label: "Total Intangible Assets",
    holder: "Operations",
    sublevel: [
      { skey: "goodwill", slabel: "Goodwill" }
    ],
  },
  {
    key: "totalLongTermAssetsUnderDevelopment",
    label: "Total Long Term Assets under development",
    holder: "Operations",
    sublevel: [
      { skey: "capitalWorkInProgress", slabel: "Capital Work In Progress" },
      { skey: "intangibleAssetsUnderDevelopment", slabel: "Intangible Assets Under Development" }
    ],
  },

  // HR Metrics
  {
    key: "totalEmployeeCost",
    label: "Total Employee Cost",
    holder: "HR",
    sublevel: [
      { skey: "employeeBenefitExpense", slabel: "Employee Benefit Expense" }
    ],
  },

  // Finance Metrics
  {
    key: "totalWorkingCapital",
    label: "Total Working Capital",
    holder: "Finance",
    sublevel: [
      { skey: "totalCurrentAssets", slabel: "Total Current Assets" },
      { skey: "totalCurrentLiabilities", slabel: "Total Current Liabilities" }
    ],
  },
  {
    key: "totalFinancialAssets",
    label: "Total Financial Assets",
    holder: "Finance",
    sublevel: [
      { skey: "bankBalancesOtherThan32", slabel: "Bank Balances Other Than 32" },
      { skey: "cashAndCashEquivalents", slabel: "Cash And Cash Equivalents" },
      { skey: "currInvestments", slabel: "Current Investments" },
      { skey: "currLoans", slabel: "Current Loans" }
    ],
  },
  {
    key: "totalInterest",
    label: "Total Interest",
    holder: "Finance",
    sublevel: [
      { skey: "financeCosts", slabel: "Finance Costs" }
    ],
  },
  {
    key: "totalTax",
    label: "Total Tax",
    holder: "Finance",
    sublevel: [
      { skey: "currentTax", slabel: "Current Tax" },
      { skey: "deferredTax", slabel: "Deferred Tax" }
    ],
  },
  {
    key: "totalDebt",
    label: "Total Debt",
    holder: "Finance",
    sublevel: [
      { skey: "ltBorrowings", slabel: "Long Term Borrowings" },
      { skey: "stBorrowings", slabel: "Short Term Borrowings" }
    ],
  },
  {
    key: "totalShareholdersEquity",
    label: "Total Shareholders Equity",
    holder: "Finance",
    sublevel: [
      { skey: "equityShareCapital", slabel: "Equity Share Capital" },
      { skey: "otherEquity", slabel: "Other Equity" }
    ],
  }
];
const SegmentActivity = (props) => {
  const dispatch = useDispatch();
  const { sectorId } = useParams();
  const { loading: loadingSectorWise, data: sectorWiseData } = useSelector(
    (state) => state.sectorWiseReducer
  );
  console.log("====SegmentActivity", loadingSectorWise, sectorWiseData);
  const navigation = useNavigate();
  // const { setIsTour } = useTourContext();
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);
  // const { data } = useSelector((state) => state.homeReducer.sectorWiseSection);
  const [showCurrentFY, setShowCurrentFY] = useState(false);
  const [observation_tour, setObservationTour] = useState(false);
  const [advisory_tour, setAdvisoryTour] = useState(false);
  // const [selectedSector, setSelectedSector] = useState("");
  // const [sectorWiseData, setSectorWiseData] = useState([]);
  const [currentSegmentRiskTab, setCurrentSegmentRiskTab] =
    useState("Financing & Growth");
  // const [benchMarkClient, setBenchMarkClient] = useState(
  //   localStorage.getItem("benchmark") || ""
  // );
  const [currentSegmentMetric, setCurrentSegmentMetric] = useState(
    TYPES_OF_SEGMENT_METRICS[0].label
  );
  const [modelRegistrationPopUp, setModelRegistrationPopUp] = useState(false);

  const [industryPayloadApi, setIndustryPayloadApi] = useState(null);
  const [isObservationContent, setIsObservationContent] = useState(true);
  const [graphData, setGraphData] = useState({
    totalShareholdersEquity: [],
    totalDebt: [],
    totalSales: [],
    totalEbitda: [],
    totalTangibleAssets: [],
    totalIntangibleAssets: [],
    totalFinancialAssets: [],
    totalLongTermAssetsUnderDevelopment: [],
    totalMaterialsCost: [],
    totalInterest: [],
    totalEmployeeCost: [],
    totalTax: [],
    averageInventory: [],
    totalWorkingCapital: [],
    totalTradeReceivables: [],
    totalTradePayables: [],
  });

  useEffect(() => {
    dispatch(getSectorWiseById(sectorId));
  }, [dispatch, sectorId]);
   // Add error effect
  useEffect(() => {
    if (getSectorWiseById) {
      console.error("Sector Wise API Error:", getSectorWiseById);
      // You can show a toast or error message here
    }
  }, [getSectorWiseById]);

  useEffect(() => {
    const yearsWiseData = sectorWiseData?.yearWiseData;
    const years = yearsWiseData && Object.keys(yearsWiseData);
    var industryObservationPayload = {};
    // setPloading(true);
    setIsObservationContent(true);
    if (yearsWiseData && years.length > 0) {
      sectorWiseMetricKeys.forEach((key) => {
        const obj = years.map((year) => {
          const d = Object.keys(yearsWiseData[year][key]);

          let total = 0;
          d.forEach((dd) => {
            total += yearsWiseData[year][key][dd];
          });

          return {
            year,
            value: { ...yearsWiseData[year][key] },
            total,
          };
        });
        const objFilter = obj.filter(
          (data) => showCurrentFY || (!showCurrentFY && data.year !== "2024")
        );
        setGraphData((currState) => {
          return {
            ...currState,
            [key]: objFilter,
          };
        });
        let particulars = [];
        let values = {};
        objFilter.forEach((data) => {
          // console.log(data);
          particulars.push(data.year);
          var value = data.value;
          var vkeys = Object.keys(value);
          vkeys.forEach((vkey) => {
            if (!values[vkey]) {
              values[vkey] = [];
            }
            values[vkey].push(value[vkey]);
          });
        });
        industryObservationPayload[key] = {
          particulars,
          ...values,
        };
      });
      setIndustryPayloadApi(industryObservationPayload);
      setIsObservationContent(false);
      // setPloading(false);
    }
  }, [showCurrentFY, sectorWiseData, loadingSectorWise]);
  const imageObject = {
    Sales: sales,
    Distribution: distribution,
    HR: hr,
    Production: production,
    Operations: operation,
    Finance: financing,
  };
   const { sector } = useSelector((state) => state.sectorWiseReducer);
  const { currentSector } = useSelector((state) => state.sectorSummaryReducer);


 const calculateObservations = (metricKey) => {
  const metricData = graphData[metricKey];
  if (!metricData || metricData.length === 0) return {
    percentage: 0,
    trend: 'no data',
    direction: 'neutral'
  };

  
  const yearsWithData = metricData.filter(item => item.total > 0).length;
  const totalYears = metricData.length;
  const percentage = Math.round((yearsWithData / totalYears) * 100);

  // Calculate trend direction and description
  let trend = 'stable';
  let direction = 'neutral';
  
  if (yearsWithData >= 2) {
    const validDataPoints = metricData.filter(item => item.total > 0);
    const firstValue = validDataPoints[0].total;
    const lastValue = validDataPoints[validDataPoints.length - 1].total;
    const percentageChange = ((lastValue - firstValue) / firstValue) * 100;

    if (percentageChange > 15) {
      trend = 'steady increase';
      direction = 'up';
    } else if (percentageChange < -15) {
      trend = 'steady decrease';
      direction = 'down';
    } else if (percentageChange > 5) {
      trend = 'moderate increase';
      direction = 'up';
    } else if (percentageChange < -5) {
      trend = 'moderate decrease';
      direction = 'down';
    }
  }

  return {
    percentage,
    trend,
    direction,
    // Optional: include actual values for debugging
    firstValue: metricData[0]?.total,
    lastValue: metricData[metricData.length - 1]?.total
  };
};

 const [hasTriedAccess, setHasTriedAccess] = useState(false);

  const handleTryAccess = () => {
    if (!isAuthenticatedUser) {
      setHasTriedAccess(true);
    }
  };
// Add this function in your SegmentActivity component
const getHolderObservations = (holder) => {
  // Find all metrics for this holder
  const holderMetrics = segmentMetricKeysMapper.filter(m => m.holder === holder);
  
  // Calculate observations for each metric
  const observations = {};
  holderMetrics.forEach(metric => {
    const obs = calculateObservations(metric.key);
    if (obs) {
      observations[metric.label] = obs; // Using label for display
    }
  });
  
  return observations;
};


  return (
    <Box className="sector-container" style={{ height: "100%" }}>
      <Flex id={"segment_risk_container"} style={{ height: "100%" }}>
        <SegmentTabs
          setCurrentSegmentMetric={setCurrentSegmentMetric}
          currentSegmentMetric={currentSegmentMetric}
          style={{ 
    height: "100%",
    overflowY: "auto",
    minWidth: "450px" 
  }}
        />
        <Box
          display={"none"}
          id={"segment_risks_type"}
          className="leftNavOptions"
        >
          {TYPES_OF_SEGMENT_METRICS?.map((data) => (
            <Box
              m={"0px"}
              w={"100%"}
              style={{
                border: "1.3px solid var(--sylvr-text-color-selected)",
                backgroundColor: "#F2F7F7",
                borderRadius: "4px",
                padding: "8px",
                marginBottom: "15px",
                
              }}
            >
              <Box>
                <Flex
                
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                    paddingBottom: "5px",
                  }}
                  onClick={() => {
                    setCurrentSegmentMetric(data?.label);
                  }}
                >
                  <Box className="sylvr-title-menu">{data?.label}</Box>
                  <Box className="menu-icon">
                    <img
                      src={
                        currentSegmentMetric === data?.label
                          ? uparrowmenu
                          : downarrowmenu
                      }
                      alt="menu-arrow"
                      className="metric-arrow"
                    />
                  </Box>
                </Flex>
              </Box>
              {currentSegmentMetric === data?.label &&
                data?.value?.map((value) => (
                  <Box
                    m={"0px"}
                    w={"100%"}
                    style={{
                      backgroundColor: "var(--sylvr-text-color-selected)",
                      borderRadius: "4px",
                      marginBottom: "10px",
                    }}
                  >
                    <Flex justifyContent={"flex-start"} alignItems={"center"}>
                      <Box style={{ marginLeft: "9px" }}>
                        <img src={imageObject[value?.label]} />
                      </Box>
                      <Box className="sylvr-subtitle-menu">{value?.label}</Box>
                    </Flex>
                    {value?.value?.map((row, index) => (
                      <>
                        <Box
                          className={
                            index === value?.value?.length - 1
                              ? "sylvr-subtitle-menu-card metric-bottomBorderRadius"
                              : "sylvr-subtitle-menu-card"
                          }
                        >
                          <Box className="sylvr-subtitle-label">
                            {row?.label}
                          </Box>
                        </Box>
                        {index != value?.value?.length - 1 && (
                          <Box
                            style={{
                              // margin: "0px 5px",
                              backgroundColor: "white",
                            }}
                          >
                            <Box
                              style={{
                                border: "1.5px solid #E6E6E6",
                                margin: "0px 5px",
                              }}
                            ></Box>
                          </Box>
                        )}
                      </>
                    ))}
                  </Box>
                ))}
            </Box>
          ))}







        </Box>
        {loadingSectorWise ? (
          <Loader />
        ) : (
          <Box className={"segment_risks_block"}>
            <Box id="activityLabel">
              ACTIVITY OF {sectorWiseData?.totalClients} SME’S
            </Box>
            <Box id={"segment_risks_content"}>
              <Box
                id={"segment_risks_graph"}
                className={props.observe_trends ? "show-zindex" : ""}
                style={{
    flex: 1,
    overflowY: "hidden",
    padding: "10px",
    height: "100%",
    maxHeight: "900px", 
  }}
              >
                <Flex justifyContent={"end"} mr="15px">
                  <Tooltip
                    label={
                      "Yes: SMEs with pending 2023-24 results are excluded, No: SMEs till 2022-23 data only"
                    }
                    fontSize="11px"
                    hasArrow
                    placement="top"
                    bg={"#F8F8F8"}
                    color={"#8F8F8F"}
                  >
                    <Box id="activityLabel">
                      <label style={{ margin: "0px 5px" }}>Show 2023-24</label>
                      <Switch
                        className="yearToggle"
                        onChange={() => setShowCurrentFY(!showCurrentFY)}
                        colorScheme="teal"
                      />
                    </Box>
                  </Tooltip>
                </Flex>
                {props.financial_growth && (
                  <Box className="financial_growth-tooplip add-segments-picture financial_growth-position">
                    <Flex padding="15px 15px 0px">
                      <Flex w="100%" justifyContent={"space-between"}>
                        <Flex>
                          <Box>
                            <Img src={bulb_on} alt="alert" />
                          </Box>
                          <Box className="add-client">
                            Complete the industry picture
                          </Box>
                        </Flex>
                        <Box
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            props.setFinancialGrowth(false);
                            // setIsTour(false);
                          }}
                        >
                          <Img src={cross_icon} alt="cross_icon" />
                        </Box>
                      </Flex>
                    </Flex>
                    <Box className="single-dashboard">
                      By observing, decoding and connecting the dots of various
                      dynamics.
                    </Box>
                    <Box className="next-block">
                      <Box
                        className="next-btn"
                        onClick={() => {
                          props.setFinancialGrowth(false);
                          props.setBenchmarkNow(true);
                          navigation(`/agency/practice-dashboard`);
                        }}
                      >
                        Take the tour for Practice Dashboard
                      </Box>
                    </Box>
                  </Box>
                )}
                {props.observe_trends && (
                  <Box className="trends-tooplip add-segments-picture trends-position">
                    <Flex padding="15px 15px 0px">
                      <Flex w="100%" justifyContent={"space-between"}>
                        <Flex>
                          <Box>
                            <Img src={bulb_on} alt="alert" />
                          </Box>
                          <Box className="add-client">Observe trends</Box>
                        </Flex>
                        <Box
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            props.setObserveTrends(false);
                            // setIsTour(false);
                          }}
                        >
                          <Img src={cross_icon} alt="cross_icon" />
                        </Box>
                      </Flex>
                    </Flex>
                    <Box className="single-dashboard">
                      Note the aggregate activity of SMEs across a full business
                      cycle. Dig deeper in next step.
                    </Box>
                    <Box className="trends-bar">
                      <Box className="trends-bar-fill"></Box>
                    </Box>
                    <Box className="next-block">
                      <Box
                        className="next-btn"
                        onClick={() => {
                          props.setObserveTrends(false);
                          setObservationTour(true);
                        }}
                      >
                        Next
                      </Box>
                    </Box>
                  </Box>
                )}
               
                <Box
                  className="activity-content-graph"
                  data-isautherised={isAuthenticatedUser ? "true" : "false"}
                >
                  {sectorWiseData?.yearWiseData &&
                    Object.keys(sectorWiseData?.yearWiseData).length > 0 && (
                      <>
                       <Box className="activity-content-graph-data">
                        
  {currentSegmentMetric === "Sales" && (
    // <Sales
    //   graphData={graphData}
    //   isAuthenticatedUser={isAuthenticatedUser}
    // />
   <Sales
      graphData={graphData}
      isAuthenticatedUser={isAuthenticatedUser}
      observations={{
        totalSales: calculateObservations('totalSales'),
        totalEbitda: calculateObservations('totalEbitda')
      }}
    />
  )}
  {currentSegmentMetric === "Distribution" && (
    // <Distribution
    //   graphData={graphData}
    //   isAuthenticatedUser={isAuthenticatedUser}
    // />
    <Distribution
  graphData={graphData}
  isAuthenticatedUser={isAuthenticatedUser}
  observations={{
    totalTradeReceivables: calculateObservations('totalTradeReceivables'),
    averageInventory: calculateObservations('averageInventory')
  }}
/>
  )}
  {currentSegmentMetric === "Production" && (
    <Production
  graphData={graphData}
  isAuthenticatedUser={isAuthenticatedUser}
  observations={{
    totalMaterialsCost: calculateObservations('totalMaterialsCost'),
    totalTradePayables: calculateObservations('totalTradePayables')
  }}
/>
  )}
  {currentSegmentMetric === "Operations" && (
   <Operations
  graphData={graphData}
  isAuthenticatedUser={isAuthenticatedUser}
  observations={{
    totalTangibleAssets: calculateObservations('totalTangibleAssets'),
    totalIntangibleAssets: calculateObservations('totalIntangibleAssets'),
    totalLongTermAssetsUnderDevelopment: calculateObservations('totalLongTermAssetsUnderDevelopment')
  }}
/>
  )}
  {currentSegmentMetric === "HR" && (
   <HR
  graphData={graphData}
  isAuthenticatedUser={isAuthenticatedUser}
  observations={{
    totalEmployeeCost: calculateObservations('totalEmployeeCost')
  }}
/>
  )}
  {currentSegmentMetric === "Finance" && (
   <Finance
  graphData={graphData}
  isAuthenticatedUser={isAuthenticatedUser}
  observations={{
    totalWorkingCapital: calculateObservations('totalWorkingCapital'),
    totalFinancialAssets: calculateObservations('totalFinancialAssets'),
    totalInterest: calculateObservations('totalInterest'),
    totalTax: calculateObservations('totalTax'),
    totalDebt: calculateObservations('totalDebt'),
    totalShareholdersEquity: calculateObservations('totalShareholdersEquity')
  }}
/>
  )}
</Box>
                      </>
                    )}
                </Box>
              </Box>
              <Box id={"segment_risks_observations"} height={"100%"}>
                {observation_tour && (
                  <Box className="observations-tooplip add-segments-picture observations-position">
                    <Flex p="15px">
                      <Flex w="100%" justifyContent={"space-between"}>
                        <Flex>
                          <Box>
                            <Img src={bulb_on} alt="alert" />
                          </Box>
                          <Box className="add-client">
                            Read through patterns
                          </Box>
                        </Flex>
                        <Box
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setObservationTour(false);
                            // setIsTour(false);
                          }}
                        >
                          <Img src={cross_icon} alt="cross_icon" />
                        </Box>
                      </Flex>
                    </Flex>
                    <Box className="single-dashboard">
                      Decode correlations, causations and contradictions across
                      variables. Connect the dots in next step.
                    </Box>
                    <Box className="trends-bar">
                      <Box className="observations-bar-fill"></Box>
                    </Box>
                    <Box className="next-block">
                      <Box
                        className="next-btn"
                        onClick={() => {
                          setObservationTour(false);
                          setAdvisoryTour(true);
                        }}
                      >
                        Next
                      </Box>
                    </Box>
                  </Box>
                )}
                {advisory_tour && (
                  <Box className="advisory-tooplip add-segments-picture advisory-position">
                    <Flex p="15px">
                      <Flex w="100%" justifyContent={"space-between"}>
                        <Flex>
                          <Box>
                            <Img src={bulb_on} alt="alert" />
                          </Box>
                          <Box className="add-client">Save & share notes</Box>
                        </Flex>
                        <Box
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setAdvisoryTour(false);
                            // setIsTour(false);
                          }}
                        >
                          <Img src={cross_icon} alt="cross_icon" />
                        </Box>
                      </Flex>
                    </Flex>
                    <Box className="single-dashboard">Grow trust today</Box>
                    <Box className="trends-bar">
                      <Box className="advisory-bar-fill"></Box>
                    </Box>
                    <Box className="next-block">
                      <Box
                        className="next-btn"
                        onClick={() => {
                          setAdvisoryTour(false);
                          props.setBenchmarkNow(true);
                        }}
                      >
                        Next
                      </Box>
                    </Box>
                  </Box>
                )}

                
                {/* <SectorChatbot 
      sectorId={sectorId} 
      observations={getHolderObservations(currentSegmentMetric, calculateObservations)}
    /> */}
  
     

  <Box 
    onClick={() => {
      if (!isAuthenticatedUser) handleTryAccess();
    }}
    filter={!isAuthenticatedUser && hasTriedAccess ? "blur(3px)" : "none"}
    pointerEvents={!isAuthenticatedUser && hasTriedAccess ? "none" : "auto"}
  >
    <SectorChatbot 
      sectorId={sectorId} 
      observations={getHolderObservations(currentSegmentMetric, calculateObservations)}
    />
  </Box>

 
 

 
  {!isAuthenticatedUser && hasTriedAccess && (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      bg="rgba(255, 255, 255, 0.3)"
      zIndex="11"
    />
  )}





               
              </Box>
            </Box>
          </Box>
        )}
      </Flex>
    
    </Box>
  );
};

export default SegmentActivity;
